'use client';

import { Switch } from '@apex-titan/ui';
import { type ComponentProps } from 'react';
import {
  useController,
  type FieldValues,
  type UseControllerProps,
} from 'react-hook-form';

type FormSwitchProps<T extends FieldValues> = UseControllerProps<T> &
  Omit<
    ComponentProps<typeof Switch>,
    'checked' | 'onCheckedChange' | 'name' | 'defaultValue'
  >;

export function FormSwitch<T extends FieldValues>({
  name,
  control,
  rules,
  defaultValue,
  shouldUnregister,
  ...switchProps
}: FormSwitchProps<T>) {
  const { field } = useController({
    name,
    control,
    rules,
    defaultValue,
    shouldUnregister,
  });
  return (
    <Switch
      {...switchProps}
      ref={field.ref}
      checked={!!field.value}
      onCheckedChange={field.onChange}
      onBlur={field.onBlur}
    />
  );
}
